const EditorOpt = {
	formats: [
		"header",
		"indent",
		"list",
		"align",
		"direction",
		"bold",
		"italic",
		"size",
		"strike",
		"underline",
	],
	modules: {
		toolbar: [
			[{ header: [1, 2, 3, 4, 5, 6, false] }],
			[{ size: ["small", false, "large", "huge"] }],
			["bold", "italic", "underline", "strike"],
			[{ list: "ordered" }, { list: "bullet" }],
			[{ indent: "-1" }, { indent: "+1" }],
			[{ align: [] }],
			["clean"],
		],
	},
};
const EditorFullOpt = {
	formats: [
		"header",
		"indent",
		"list",
		"align",
		"direction",
		"bold",
		"italic",
		"size",
		"strike",
		"underline",
		"image",
	],
	modules: {
		toolbar: [
			[{ header: [1, 2, 3, 4, 5, 6, false] }],
			[{ size: ["small", false, "large", "huge"] }],
			["bold", "italic", "underline", "strike"],
			[{ script: "sub" }, { script: "super" }],
			[{ list: "ordered" }, { list: "bullet" }],
			[{ indent: "-1" }, { indent: "+1" }],
			[{ direction: "rtl" }, { align: [] }],
			["image"],
			["clean"],
		],
	},
};

const Modals = {
	COURSE: "COURSE",
	CREATE: "CREATE",
	EDIT: "EDIT",
	ROLE: "ROLE",
	SESSION: "SESSION",
	IMAGE: "IMAGE",
	TEXT: "TEXT",
	VIDEO: "VIDEO",
	SOUND: "SOUND",
};

const Patterns = {
	urlname: /^[A-Za-z]([A-Za-z0-9-]{1,48})[A-Za-z0-9-]$/,
	mobile: /^(09)[0-9]{9}$/,
	email: /^\w+([-.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
	latlong: /^[0-9]{2,3}(\.)[0-9]{6}$/,
};

const Permissions = {
	ABOUT_VIEW: "admin_panel.about_us.view",
	ABOUT_UPDATE: "admin_panel.about_us.update",

	BANNER_VIEW: "admin_panel.banner.view",
	BANNER_CREATE: "admin_panel.banner.create",
	BANNER_UPDATE: "admin_panel.banner.update",
	BANNER_STATUS: "admin_panel.banner.status",
	BANNER_DELETE: "admin_panel.banner.delete",

	CATEGORY_VIEW: "admin_panel.category.view",
	CATEGORY_CREATE: "admin_panel.category.create",
	CATEGORY_UPDATE: "admin_panel.category.update",
	CATEGORY_STATUS: "admin_panel.category.status",
	CATEGORY_DELETE: "admin_panel.category.delete",

	COMMENT_VIEW: "admin_panel.comment.view",
	COMMENT_STATUS: "admin_panel.comment.status",
	COMMENT_DELETE: "admin_panel.comment.delete",

	CONTACT_VIEW: "admin_panel.contact_us.view",
	CONTACT_UPDATE: "admin_panel.contact_us.update",

	COUPON_VIEW: "admin_panel.coupon.view",
	COUPON_CREATE: "admin_panel.coupon.create",
	COUPON_UPDATE: "admin_panel.coupon.update",
	COUPON_STATUS: "admin_panel.coupon.status",
	COUPON_DELETE: "admin_panel.coupon.delete",
	COUPON_ATTACH: "admin_panel.coupon.attach",

	COURSE_VIEW: "admin_panel.course.view",
	COURSE_CREATE: "admin_panel.course.create",
	COURSE_UPDATE: "admin_panel.course.update",
	COURSE_STATUS: "admin_panel.course.status",
	COURSE_DELETE: "admin_panel.course.delete",
	COURSE_ATTACH: "admin_panel.course.attach",

	FAQ_VIEW: "admin_panel.FAQ.view",
	FAQ_CREATE: "admin_panel.FAQ.create",
	FAQ_UPDATE: "admin_panel.FAQ.update",
	FAQ_STATUS: "admin_panel.FAQ.status",
	FAQ_DELETE: "admin_panel.FAQ.delete",

	FILES_VIEW: "admin_panel.file.view",
	FILES_CREATE: "admin_panel.file.create",
	FILES_UPDATE: "admin_panel.file.update",
	FILES_DELETE: "admin_panel.file.delete",

	SOUND_VIEW: "admin_panel.sound.view",
	SOUND_CREATE: "admin_panel.sound.create",
	SOUND_UPDATE: "admin_panel.sound.update",
	SOUND_DELETE: "admin_panel.sound.delete",

	NOTIFICATION_VIEW: "admin_panel.notification.view",
	NOTIFICATION_CREATE: "admin_panel.notification.create",
	NOTIFICATION_UPDATE: "admin_panel.notification.update",
	NOTIFICATION_STATUS: "admin_panel.notification.status",
	NOTIFICATION_DELETE: "admin_panel.notification.delete",

	ORDER_VIEW: "admin_panel.order.view",

	PACKAGE_VIEW: "admin_panel.package.view",
	PACKAGE_CREATE: "admin_panel.package.create",
	PACKAGE_UPDATE: "admin_panel.package.update",
	PACKAGE_STATUS: "admin_panel.package.status",
	PACKAGE_DELETE: "admin_panel.package.delete",

	PLATFORM_VIEW: "admin_panel.platform.view",
	PLATFORM_CREATE: "admin_panel.platform.create",
	PLATFORM_UPDATE: "admin_panel.platform.update",
	PLATFORM_STATUS: "admin_panel.platform.status",
	PLATFORM_DELETE: "admin_panel.platform.delete",

	ROLE_VIEW: "admin_panel.role.view",
	ROLE_CREATE: "admin_panel.role.create",
	ROLE_UPDATE: "admin_panel.role.update",
	ROLE_STATUS: "admin_panel.role.status",
	ROLE_DELETE: "admin_panel.role.delete",
	ROLE_ATTACH: "admin_panel.role.attach",

	SAMPLE_VIEW: "admin_panel.sample.view",
	SAMPLE_CREATE: "admin_panel.sample.create",
	SAMPLE_UPDATE: "admin_panel.sample.update",
	SAMPLE_STATUS: "admin_panel.sample.status",
	SAMPLE_DELETE: "admin_panel.sample.delete",

	SESSION_VIEW: "admin_panel.course_session.view",
	SESSION_CREATE: "admin_panel.course_session.create",
	SESSION_UPDATE: "admin_panel.course_session.update",
	SESSION_STATUS: "admin_panel.course_session.status",
	SESSION_DELETE: "admin_panel.course_session.delete",

	SESSION_VIDEO_VIEW: "admin_panel.session_video.view",
	SESSION_VIDEO_CREATE: "admin_panel.session_video.create",
	SESSION_VIDEO_UPDATE: "admin_panel.session_video.update",
	SESSION_VIDEO_DELETE: "admin_panel.session_video.delete",

	SETTING_UPDATE: "admin_panel.setting.update",

	ROLE_VIEW: "admin_panel.role.view",
	ROLE_CREATE: "admin_panel.role.create",
	ROLE_UPDATE: "admin_panel.role.update",
	ROLE_STATUS: "admin_panel.role.status",
	ROLE_DELETE: "admin_panel.role.delete",
	ROLE_ATTACH: "admin_panel.role.attach",

	TAC_VIEW: "admin_panel.TAC.view",
	TAC_UPDATE: "admin_panel.TAC.update",

	TRANSACTION_VIEW: "admin_panel.transaction.view",

	USER_VIEW: "admin_panel.user.view",
	USER_CREATE: "admin_panel.user.create",
	USER_UPDATE: "admin_panel.user.update",
	USER_STATUS: "admin_panel.user.status",
	USER_DELETE: "admin_panel.user.delete",

	VERSION_VIEW: "admin_panel.version.view",
	VERSION_CREATE: "admin_panel.version.create",
	VERSION_UPDATE: "admin_panel.version.update",
	VERSION_DELETE: "admin_panel.version.delete",
};

const Status = {
	default: { active: "active", inactive: "inactive" },
};

const Types = {
	status: { active: "active", pending: "pending" },
	upload: {
		banner: "banner",
		category: "category",
		course: "course",
		package: "package",
		default: "default",
		sample: "sample",
		session: "session",
		user: "user",
		group: "group",
		platform: "platform",
	},
	uploadImageFormats: ["image/jpg", "image/jpeg", "image/png", "image/bmp"],
	uploadFileFormats: ["application/pdf", "audio/mpeg", "audio/ogg", "audio/mp3", "audio/x-m4a"],
	uploadSoundFileFormats: ["audio/ogg", "audio/mp3"],
	uploadVideoFormats: [
		"video/mp4",
		"video/webm",
		"image/mkv",
		"image/m4v",
		"image/flv",
		"image/gif",
	],
	notifications: {
		error: "error",
		info: "info",
		success: "success",
		warning: "warning",
	},
};

export {
	EditorOpt,
	EditorFullOpt,
	Modals,
	Patterns,
	Permissions,
	Status,
	Types,
};
